module.exports = __webpack_public_path__ + "img/_heritage.b5268dc5.jpg";